import Vue from 'vue';

export const GlobalLoader = new Vue({
    data() {
        return {
            count: 0,
            isSilent: false,
            isPrinting: false,
            cancelRequested: false
        };
    },
    computed: {
        isActive() {
            return this.count > 0 && !this.isSilent;
        }
    },
    methods: {
        start() {
            this.count++;
        },
        stop() {
            this.count = Math.max(0, this.count - 1);
        },
        reset() {
            this.count = 0;
            this.isPrinting = false;
            this.cancelRequested = false;
        },
        setSilent(val = true) {
            this.isSilent = val;
        },
        setPrinting(val = true) {
            this.isPrinting = val;
            this.cancelRequested = false;
        },
        requestCancel() {
            this.cancelRequested = true;
        },
        async wrap(promise) {
            this.start();
            try {
                return await promise;
            } finally {
                this.stop();
            }
        }
    }
});
